import React from 'react'

import realtimeMessaging from '@scoir/realtime-messaging'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import context from './context'

export class RealtimeMessagingProvider extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    userId: PropTypes.string.isRequired,
  }
  rt = realtimeMessaging.init(this.props.userId)
  ctxVal = {
    connect: (...args) => this.rt.connect(...args),
    logout: (...args) => this.rt.logout(...args),
    publish: (...args) => this.rt.publish(...args),
    disconnect: (...args) => this.rt.disconnect(...args),
  }
  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.rt.logout()
      this.rt = realtimeMessaging.init(this.props.userId)
    }
  }
  render() {
    return <context.Provider value={this.ctxVal}>{this.props.children}</context.Provider>
  }
}
export default connect((store) => ({
  userId: store.user.record.Id,
}))(RealtimeMessagingProvider)
